import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'ul';
const idGen = new IDGenerator('wm_nav');

register('wm-nav', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmListenProperty="dataset" wmNav wmsTransclude data-element-type="wmNav" data-role="page-header" role="list" #${counter}="wmNav" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
